import useRepo from '@/nebula/repo';
import { printable as printableConfig } from 'shared/api/query/configs.json';

export default function usePrintable() {
  const repo = useRepo(printableConfig.model);

  return { ...repo };
}
